import React from 'react'
import { Page, View, Image, StyleSheet, Text, Font } from '@react-pdf/renderer'
import { ItemsPrint, PrintPage, TipologyItemPrint, VariantTipologyPrint } from '../../types/user'
import HeaderPrint from './HeaderPrint'
import FooterPrint from './FooterPrint'
import { styles } from './styles'
import { transformToCurrency } from '../../utilities/functions'
import { PrintType } from '../../utilities/PrintType'

interface Props {
    tipology: TipologyItemPrint
    printFile: PrintPage
    currentItem: ItemsPrint
    index: number
}

const ComposedTypologyPage: React.FC<Props> = (props) => {
    const tipology = props.tipology
    const printFile = props.printFile
    const arraySons = props.currentItem.tipologies.filter((t) => t.IDComposta == props.tipology.id)

    const renderPrices = () => {
        let price = 0
        let priceNoSale = 0
        let priceRif = 0
        arraySons.forEach((s) => {
            price += s.price
            priceNoSale += s.priceNoSale
            priceRif += s.priceRif
        })
        return {
            price: price,
            priceNoSale: priceNoSale,
            priceRif: priceRif
        }
    }

    const renderVariants = (variants: VariantTipologyPrint[]) => {
        if (tipology) {
            return variants.map((v, i) => {
                return (
                    <View
                        key={v.name + v.price}
                        style={{
                            paddingTop: 5,
                            paddingHorizontal: 5,
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            backgroundColor: i % 2 == 0 ? '#fff' : '#ececec'
                        }}
                    >
                        <View style={{ flexDirection: 'row', flex: 1, overflow: 'hidden', flexWrap: 'wrap' }}>
                            <Text style={[styles.boldText, { fontSize: 10 }]}>{v.name}: </Text>
                            <Text style={[styles.standardText, { fontSize: 10 }]}>{v.value}</Text>
                        </View>
                        {printFile.printType !== PrintType.ONLY_FINAL && printFile.printType !== PrintType.NO_PRICES ? (
                            <View style={{ marginLeft: 10 }}>
                                <Text style={[styles.boldText, { fontSize: 10 }]}>{v.price !== 0 ? transformToCurrency(v.price) : ''}</Text>
                            </View>
                        ) : null}
                    </View>
                )
            })
        }
    }

    const prices = renderPrices()

    const foundSale = ((prices.price - prices.priceNoSale) * 100) / prices.priceNoSale

    const renderSons = () => {
        return arraySons.map((s, i) => {
            return (
                <View key={s.id} break>
                    <View style={{ width: '100%' }}>
                        <View style={{ paddingHorizontal: 20 }}>
                            <View>
                                <Text
                                    style={{ ...styles.standardSmallText, textTransform: 'uppercase', color: '#000', fontSize: 10 }}
                                    render={({ pageNumber }) =>
                                        `RIFERIMENTO A FINESTRA COMPOSTA: ${tipology.label} (${tipology.dimensions.width} x ${
                                            tipology.dimensions.height
                                        } mm.) - Pagina ${pageNumber - (i + 1)}`
                                    }
                                />
                                <Text style={{ ...styles.subtitle, marginTop: 0 }}>
                                    {s.description} ({s.dimensions.width} x {s.dimensions.height} mm.)
                                </Text>
                                <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <View style={{ flex: 1 }}>
                                        <Text style={styles.standardText}>
                                            Etichetta: {tipology.label} - {s.label}
                                        </Text>
                                    </View>
                                    <View style={{ flex: 1 }}>
                                        <Text style={styles.standardText}>N° ordinamento: {s.order}</Text>
                                    </View>
                                </View>
                                <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <View style={{ flex: 1 }}>
                                        <Text style={styles.standardText}>Quantità: {s.quantity} pz</Text>
                                    </View>
                                    {printFile.printType !== PrintType.ONLY_FINAL && printFile.printType !== PrintType.NO_PRICES ? (
                                        <View style={{ flex: 1 }}>
                                            <Text style={styles.standardText}>Prezzo base: {transformToCurrency(s.priceRif)}</Text>
                                        </View>
                                    ) : null}
                                </View>
                            </View>
                            <View>
                                <Text style={{ ...styles.subtitle }}>Elenco varianti</Text>
                                {renderVariants(s.variants)}
                            </View>
                        </View>
                        <View wrap={false} style={{ paddingHorizontal: 20 }}>
                            <Text style={styles.subtitle}>Dati tecnici</Text>
                            <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
                                {s.dimensions.weight && tipology.dimensions.weight !== '0' ? (
                                    <View
                                        style={{
                                            flex: 1,
                                            justifyContent: 'center',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            textAlign: 'center',
                                            alignItems: 'center'
                                        }}
                                    >
                                        <Text style={{ ...styles.standardText, fontSize: 12 }}>Peso</Text>
                                        <Text style={{ ...styles.standardText, ...{ fontSize: 12, fontWeight: 700, color: '#000' } }}>
                                            {s.dimensions.weight} kg.
                                        </Text>
                                    </View>
                                ) : null}
                                {s.dimensions.heightManiglia ? (
                                    <View
                                        style={{
                                            flex: 1,
                                            justifyContent: 'center',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            textAlign: 'center',
                                            alignItems: 'center'
                                        }}
                                    >
                                        <Text style={{ ...styles.standardText, fontSize: 12 }}>HMan.</Text>
                                        <Text style={{ ...styles.standardText, ...{ fontSize: 12, fontWeight: 700, color: '#000' } }}>
                                            {s.dimensions.heightManiglia} mm.
                                        </Text>
                                    </View>
                                ) : null}
                                {s.dimensions.heightTraverso1 ? (
                                    <View
                                        style={{
                                            flex: 1,
                                            justifyContent: 'center',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            textAlign: 'center',
                                            alignItems: 'center'
                                        }}
                                    >
                                        <Text style={{ ...styles.standardText, fontSize: 12 }}>HTrav. 1</Text>
                                        <Text style={{ ...styles.standardText, ...{ fontSize: 12, fontWeight: 700, color: '#000' } }}>
                                            {s.dimensions.heightTraverso1} mm.
                                        </Text>
                                    </View>
                                ) : null}
                                {s.dimensions.heightTraverso2 ? (
                                    <View
                                        style={{
                                            flex: 1,
                                            justifyContent: 'center',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            textAlign: 'center',
                                            alignItems: 'center'
                                        }}
                                    >
                                        <Text style={{ ...styles.standardText, fontSize: 12 }}>HTrav. 2</Text>
                                        <Text style={{ ...styles.standardText, ...{ fontSize: 12, fontWeight: 700, color: '#000' } }}>
                                            {s.dimensions.heightTraverso2} mm.
                                        </Text>
                                    </View>
                                ) : null}
                                {s.dimensions.heightTraverso3 ? (
                                    <View
                                        style={{
                                            flex: 1,
                                            justifyContent: 'center',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            textAlign: 'center',
                                            alignItems: 'center'
                                        }}
                                    >
                                        <Text style={{ ...styles.standardText, fontSize: 12 }}>HTrav. 3</Text>
                                        <Text style={{ ...styles.standardText, ...{ fontSize: 12, fontWeight: 700, color: '#000' } }}>
                                            {s.dimensions.heightTraverso3} mm.
                                        </Text>
                                    </View>
                                ) : null}
                                {s.dimensions.heightTraverso4 ? (
                                    <View
                                        style={{
                                            flex: 1,
                                            justifyContent: 'center',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            textAlign: 'center',
                                            alignItems: 'center'
                                        }}
                                    >
                                        <Text style={{ ...styles.standardText, fontSize: 12 }}>HTrav. 4</Text>
                                        <Text style={{ ...styles.standardText, ...{ fontSize: 12, fontWeight: 700, color: '#000' } }}>
                                            {s.dimensions.heightTraverso4} mm.
                                        </Text>
                                    </View>
                                ) : null}
                            </View>
                            <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                                {s.features.map((f) => {
                                    return (
                                        <View
                                            key={f.name}
                                            style={{
                                                flex: 1,
                                                justifyContent: 'center',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                textAlign: 'center',
                                                alignItems: 'center'
                                            }}
                                        >
                                            <Image src={f.icon} style={{ width: 30, height: 30, borderRadius: 20, objectFit: 'contain' }} />
                                            <Text style={{ ...styles.standardText, fontSize: 12 }}>{f.name}</Text>
                                            <Text style={{ ...styles.standardText, ...{ fontSize: 12, fontWeight: 700, color: '#000' } }}>{f.value}</Text>
                                        </View>
                                    )
                                })}
                            </View>
                        </View>
                    </View>
                </View>
            )
        })
    }

    return (
        <Page size="A4" style={{ display: 'flex', flexDirection: 'column' }}>
            <HeaderPrint printFile={printFile} />
            <View style={{ width: '100%' }}>
                <View style={{ paddingHorizontal: 20 }}>
                    <View style={{ display: 'flex', flexDirection: 'row' }}>
                        <View style={{ flex: 1.2 }}>
                            <Image src={tipology.img} style={{ width: '100%', objectFit: 'contain' }} />
                            <View style={{ height: 20 }}>
                                <Text style={styles.standardText}>N° progressivo: {props.index}</Text>
                            </View>
                            <View style={{ height: 20 }}>
                                <Text style={styles.standardText}>Etichetta: {tipology.label}</Text>
                            </View>
                            <View style={{ height: 20 }}>
                                <Text style={styles.standardText}>N° ordinamento: {tipology.order}</Text>
                            </View>
                        </View>
                        <View style={{ flex: 2.5, paddingLeft: 10 }}>
                            <Text style={styles.subtitle}>
                                {tipology.description} ({tipology.dimensions.width} x {tipology.dimensions.height} mm.)
                            </Text>
                            {/* <View style={{ flexDirection: 'row', justifyContent: 'space-between', }}>
                                <View style={{ flex: 1 }}>
                                    <Text style={styles.standardText}>Etichetta: {tipology.label}</Text>
                                </View>
                                <View style={{ flex: 1 }}>
                                    <Text style={styles.standardText}>N° ordinamento: {tipology.order}</Text>
                                </View>
                            </View> */}
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                                <View style={{ flex: 1 }}>
                                    <Text style={styles.standardText}>Quantità: {tipology.quantity} pz</Text>
                                </View>
                                {printFile.printType !== PrintType.NO_PRICES ? (
                                    <View style={{ flex: 1 }}>
                                        <Text style={styles.standardText}>Prezzo base: {transformToCurrency(prices.priceRif)}</Text>
                                    </View>
                                ) : null}
                            </View>
                            <View>{renderVariants(tipology.variants)}</View>
                        </View>
                    </View>
                    {props.tipology.note ? (
                        <Text style={{ ...styles.standardText, fontSize: 12, opacity: 0.8, marginTop: 10 }}>Note: {props.tipology.note}</Text>
                    ) : null}
                    {printFile.printType !== PrintType.NO_PRICES ? (
                        <View
                            style={{
                                backgroundColor: printFile.color ? printFile.color : '#005AAB',
                                width: '100%',
                                padding: 5,
                                marginTop: 10,
                                flexDirection: 'row',
                                justifyContent: printFile.printType == PrintType.ONLY_FINAL ? 'flex-end' : 'space-between'
                            }}
                        >
                            {printFile.printType !== PrintType.ONLY_FINAL ? (
                                <Text style={{ color: '#fff', fontSize: 12, fontFamily: 'Roboto' }}>Prezzo: {transformToCurrency(prices.priceNoSale)}</Text>
                            ) : null}
                            {printFile.printType !== PrintType.ONLY_FINAL ? (
                                <Text style={{ color: '#fff', fontSize: 12, fontFamily: 'Roboto' }}>
                                    Sconto ({foundSale.toFixed(2)}%): {transformToCurrency(prices.price - prices.priceNoSale)}
                                </Text>
                            ) : null}
                            <Text style={{ color: '#fff', fontSize: 12, fontFamily: 'Roboto' }}>Prezzo finale: {transformToCurrency(prices.price)}</Text>
                        </View>
                    ) : null}

                    <View>
                        <Text style={styles.subtitle}>Elementi composta</Text>
                        <View style={{ flexDirection: 'column' }}>
                            {arraySons.map((s, i) => {
                                return (
                                    <View key={s.id} style={{ flex: 1, marginBottom: 20 }}>
                                        <Text
                                            style={styles.standardText}
                                            render={({ pageNumber, totalPages }) =>
                                                `${s.label}: ${s.description} (${s.dimensions.width} x ${s.dimensions.height} mm.) - Dettaglio a pagina ${
                                                    pageNumber + i + 1
                                                }`
                                            }
                                        />
                                    </View>
                                )
                            })}
                        </View>
                    </View>
                </View>
            </View>
            {renderSons()}
            <FooterPrint printFile={printFile} />
        </Page>
    )
}

export default ComposedTypologyPage
